import 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import '../../css/vendor/cookieconsent.scss';

function getLang() {
  const match = window.location.pathname.match(/^\/(en)(\/|$)/);
  return match ? match[1] : 'cs';
}

function updateConsent(level) {
  function gtag() { dataLayer.push(arguments); }
  gtag('consent', 'update', {
    ad_storage: level.includes('marketing') ? 'granted' : 'denied',
    analytics_storage: level.includes('analytics') ? 'granted' : 'denied',
    functionality_storage: 'granted',
  });
}

window.addEventListener('load', function() {
  window.dataLayer = window.dataLayer || [];
  function gtag() { dataLayer.push(arguments); }

  const cc = initCookieConsent();

  if (!cc.validCookie('cc_cookie')) {
    gtag('consent', 'default', {
      ad_storage: 'granted',
      analytics_storage: 'granted',
      functionality_storage: 'granted',
    });
  }

  cc.run({
    current_lang: getLang(),
    autoclear_cookies: true,
    page_scripts: true,
    cookie_expiration: 364,
    cookie_necessary_only_expiration: 182,

    onFirstAction: function(user_preferences, cookie) {
      updateConsent(cookie.level);
    },

    onAccept: function(cookie) {
    },

    onChange: function(cookie, changed_categories) {
      updateConsent(cookie.level);
    },

    languages: {
      'en': {
        consent_modal: {
          title: 'We use cookies!',
          description: 'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
          primary_btn: {
            text: 'Accept all',
            role: 'accept_all'
          },
          secondary_btn: {
            text: 'Reject all',
            role: 'accept_necessary'
          }
        },
        settings_modal: {
          title: 'Cookie preferences',
          save_settings_btn: 'Save settings',
          accept_all_btn: 'Accept all',
          reject_all_btn: 'Reject all',
          close_btn_label: 'Close',
          cookie_table_headers: [
            {col1: 'Name'},
            {col2: 'Domain'},
            {col3: 'Expiration'},
            {col4: 'Description'}
          ],
          blocks: [
            {
              title: 'Cookie usage',
              description: 'We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="https://ehub.cz/en/terms-and-conditions" class="cc-link">privacy policy</a>.'
            }, {
              title: 'Strictly necessary cookies',
              description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
              toggle: {value: 'necessary', enabled: true, readonly: true}
            }, {
              title: 'Performance and Analytics cookies',
              description: 'These cookies help us track the number of visitors to our website, where visitors come from and how they move around the site. All information collected by these cookies is aggregated and anonymous. We use them to improve the site.',
              toggle: {value: 'analytics', enabled: true, readonly: false},
              cookie_table: [
                {col1: '^_ga', col2: 'google.com', col3: '2 years', col4: '', is_regex: true},
                {col1: '_gid', col2: 'google.com', col3: '1 day', col4: ''}
              ]
            }, {
              title: 'Advertisement and Targeting cookies',
              description: 'These cookies are managed by Facebook. We use them to target and evaluate advertising on Facebook and on sites participating in the Facebook advertising platform. They do not store your personal information directly, but via unique browser and internet device identifiers.',
              toggle: {value: 'marketing', enabled: false, readonly: false}
            }, {
              title: 'More information',
              description: 'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="/en/contact">contact us</a>.',
            }
          ]
        }
      },
      'cs': {
        consent_modal: {
          title: 'Používáme cookies!',
          description: 'K provozování těchto webových stránek a zajištění personalizovanějšího uživatelského zážitku affiliate síť eHUB potřebuje váš souhlas se zpracováním cookie souborů - malé soubory, které se dočasně ukládají ve vašem prohlížeči. <button type="button" data-cc="c-settings" class="cc-link">Přizpůsobit cookies</button>',
          primary_btn: {
            text: 'Přijmout vše',
            role: 'accept_all'
          },
          secondary_btn: {
            text: 'Nepovolit',
            role: 'accept_necessary'
          }
        },
        settings_modal: {
          title: 'Nastavení cookies',
          save_settings_btn: 'Uložit',
          accept_all_btn: 'Přijmout vše',
          reject_all_btn: 'Nepovolit',
          close_btn_label: 'Zavřít',
          cookie_table_headers: [
            {col1: 'Name'},
            {col2: 'Domain'},
            {col3: 'Expiration'},
            {col4: 'Description'}
          ],
          blocks: [
            {
              title: 'Výběr cookies',
              description: 'K provozování těchto webových stránek a zajištění personalizovanějšího uživatelského zážitku affiliate síť eHUB potřebuje váš souhlas se zpracováním cookie souborů - malé soubory, které se dočasně ukládají ve vašem prohlížeči. <a href="https://ehub.cz/obchodni-podminky" class="cc-link">Obchodní podmínky</a>.'
            }, {
              title: 'Funkčně nezbytné cookies',
              description: 'Tyto cookies jsou nezbytné pro fungování těchto stránek. Bez nich by stránky správně nefungovaly.',
              toggle: {value: 'necessary', enabled: true, readonly: true}
            }, {
              title: 'Analytické cookies',
              description: 'Pomáhají nám sledovat počet návštěvníků na našem webu, odkud návštěvníci přicházejí a jak se na webu pohybují. Všechny informace, které tyto cookies shromažďují, jsou souhrnné a anonymní. Využíváme je k vylepšování webu.',
              toggle: {value: 'analytics', enabled: true, readonly: false},
              cookie_table: [
                {col1: '^_ga', col2: 'google.com', col3: '2 years', col4: '', is_regex: true},
                {col1: '_gid', col2: 'google.com', col3: '1 day', col4: ''}
              ]
            }, {
              title: 'Marketingové cookies',
              description: 'Tyto cookies spravuje společnost Facebook. Používáme je pro cílení a vyhodnocování reklamy na Facebooku a na webech zapojených do reklamní platformy Facebook. Neukládají vaše osobní informace přímo, ale přes jedinečné identifikátory prohlížeče a internetového zařízení.',
              toggle: {value: 'marketing', enabled: false, readonly: false}
            }, {
              title: 'Více informací',
              description: 'Pokud máte jakékoliv dotazy, prosím, <a class="cc-link" href="/kontakt">obraťte se na nás</a>.',
            }
          ]
        }
      }
    }
  });
});
